const isDemoEnv = () => {
  const isDemoForClientEnv = process.env.REACT_APP_DAVINCI_FRONTEND_IS_DEMO_ENV_FOR_CLIENT;
  return isDemoForClientEnv && isDemoForClientEnv.repeat(1) === 'true';
};

export default isDemoEnv;
